import { Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useNavigate } from 'react-router-dom';
import { FileIcon } from '../../../../components/Icons/FileIcon';
import { getTenantIdentifier } from '../../../../utils/getTenantIdentifier';
import { useCurrentProject } from '../../../projects/utils/useCurrentProject';
import { FormRow } from '../types';

export const FormNameCell: React.FC<GridRenderCellParams<FormRow>> = ({ row, formattedValue }) => {
  const navigate = useNavigate();

  const { projectId, canManageForms, isTemplate } = useCurrentProject();

  const canOpenForm = !isTemplate || canManageForms;
  return (
    <Stack direction='row' spacing={2} justifyContent='left' alignItems='center' height={'100%'} overflow='hidden' >
      <FileIcon fileIconType={'InternalForm'} fontSize='large' />
      <Typography
        title={formattedValue}
        sx={{ ':hover': { textDecoration: 'underline', cursor: canOpenForm ? 'pointer' : 'inherit' } }}
        onClick={!canOpenForm ? undefined : () => navigate(`/${getTenantIdentifier()}/projects/${projectId}/form/${row.id}`)}
      >
        {formattedValue}
      </Typography>

    </Stack>
  );
};